export const groupSetupKey = (value) => String(value || '')
  .replace(/\s+/g, '')
  .match(/.{1,4}/g)?.join(' ') || '';
